import moment from 'moment'
import IconButton from 'share-ui/components/IconButton/IconButton'
import Loader from 'share-ui/components/Loader/Loader'
import { StyledActionWrapper } from 'pages/ApiKeys/columnConfig'
import { StyledDeleteIcon } from 'styles/styledIcons.css'

interface RendererColumnProps {
    deleteUserAccess: (id: string) => void
    deleting_loading: {
        loading: boolean
        id: string
    }
}

interface ColumnRowProps {
    id: string
    assigned_user_name: string
    assigned_user_email: string
    created_by_email: string
    created_on: Date
    account_id: string
}

// eslint-disable-next-line react/prop-types
const DateRenderer: React.FC<{ value: Date }> = ({ value }) => {
    const formattedDate = moment(value).fromNow()
    return <span>{formattedDate}</span>
}

const base = [
    {
        Header: 'User Name',
        accessor: 'assigned_user_name',
        minWidth: 100,
        width: 150,
    },
    {
        Header: 'User email',
        accessor: 'assigned_user_email',
        minWidth: 200,
        width: 250,
    },
    {
        Header: 'App',
        accessor: 'app',
        minWidth: 100,
        width: 150,
    },
    {
        Header: 'Type',
        accessor: 'app_type',
        minWidth: 100,
        width: 150,
    },
    {
        Header: 'Created On',
        accessor: 'created_on',
        minWidth: 100,
        width: 140,
        Cell: DateRenderer,
    },
]

export const renderColumns = ({ deleteUserAccess, deleting_loading }: RendererColumnProps) => [
    ...base,
    {
        Header: 'Actions',
        accessor: 'actions',
        minWidth: 100,
        width: 130,

        Cell: ({ row: { original: data } }: { row: { original: Pick<ColumnRowProps, 'id'> } }) => (
            <StyledActionWrapper>
                <IconButton
                    onClick={() => deleteUserAccess(data.id)}
                    icon={() =>
                        deleting_loading.loading && deleting_loading.id === data.id ? (
                            <Loader size={16} />
                        ) : (
                            <StyledDeleteIcon />
                        )
                    }
                    size={IconButton.sizes?.SMALL}
                    kind={IconButton.kinds?.TERTIARY}
                    ariaLabel='Remove from team'
                />
            </StyledActionWrapper>
        ),
    },
]
